import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { BaseComponent } from '@core/base.component';
import { MatterFile } from '@models/matter-file';
import { MatterUploadedFilesDispatch } from '@state/matter/uploaded-files/matter-uploaded-files.dispatch';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

interface VM {
	file: MatterFile;
}

const defaultVM: VM = {
	file: null,
};

@Component({
	selector: 'app-ereg-file-viewer',
	templateUrl: './ereg-file-viewer.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class EregFileViewerComponent
	extends BaseComponent<VM>
	implements OnInit
{
	constructor(
		private matterUploadedFilesDispatch: MatterUploadedFilesDispatch,
		private drawerService: DrawerService,
		//eslint-disable-next-line @typescript-eslint/no-explicit-any
		@Inject(DRAWER_DATA) private data: any,
	) {
		super(defaultVM);
	}

	ngOnInit(): void {
		this.VM = {
			file: this.data.file,
		};
	}

	deleteFile() {
		this.matterUploadedFilesDispatch.Delete(this.VM.file.id);
		this.drawerService.closeDrawer();
	}
}
